// imports section Start
import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../../assets/styles/Theme";
import {
  Menu as MenuIcon,
  Cached as CachedIcon,
  Delete as DeleteIcon,
  MoreVert as MoreVertIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";
import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  TextField,
  Card,
  CardContent,
  Divider,
  MenuItem,
  Menu,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  DialogActions,
  DialogContent,
} from "@mui/material";
import {
  removeCashierItemFromCart,
  increaseCashierItemQuantity,
  decreaseCashierItemQuantity,
  updateCashierItemQuantity,
  clearCashierCart,
  updateItemAddons,
} from "../../../../store/ReduxCashierCartReducer";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { BASEURL } from "../../../../config/Config";
import {
  externalgetApi,
  externalpostApi,
} from "../../../../services/external/externalApis";
import {
  COMMON_API_01,
  COMMON_API_03,
  SETTINGS_API_06,
  COMMON_API_06,
  ORDER_API_05,
  ORDER_API_09,
  CASHIER_API_02,
  CASHIER_API_06,
  SETTINGS_API_07,
  ORDER_API_07,
} from "../../../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_TAX_PAGE_CODE,
  CON_ADDON_CODE,
  CON_IS_ADDON,
  CON_IS_CASHIER_YES,
  CON_DELIVERY_STS,
  CON_GUEST_REF_CODE,
  CON_STATUS_PENDING,
  CON_EMPTY_VALUE,
  CON_VALUE_ZERO,
  CON_IS_CREDIT_NO,
  CON_VALUE_ZERO_ST,
  CON_STATUS_RETURN,
  CON_IS_ADDON_YES,
  getCashierCeNoteClaimedLabel,
} from "../../../../utils/sys/Constants";
import { Link } from "react-router-dom";
import useClientIP from "../../../../utils/common/ClientIP";
import SnackbarMessage from "../../../../components/common/SnackbarMessage";
import {
  MSG_CASHIER_FAILED,
  MSG_CASHIER_SUCCESS,
  MSG_EMPTY_CART,
} from "../../../../utils/sys/Messages";
import { CashierContext } from "../../../../features/mobile/cashier/CashierMobile";
import { resetVouchers } from "../../../../store/ReduxVoucherSlice";
import { clearSlips } from "../../../../store/ReduxSlipSlice";
import { clearCheque } from "../../../../store/ReduxChequeSlice";
import { resetCards } from "../../../../store/ReduxCardSlice";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  setRedeemAmount,
  clearLoyaltyData,
} from "../../../../store/ReduxLoyaltySlice";
import {
  resetCreditNote,
  selectCreditNotePaymentAmount,
  selectClaimedCreditNote,
} from "../../../../store/ReduxCreditNoteSlice";
import { buildDtRefundDetParam } from "../../../../utils/cashier/buildDtRefundDetParam";
import { persistCeNoteReturnType } from "../../../../utils/cashier/cenoteReturnTypeStorage";
import { resolveCashAmountForOrderPost } from "../../../../utils/cashier/resolveCashAmountForOrderPost";

// imports section End

const CashierSummaryMobile = ({ onMoreClick, onNewOrder }) => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clientIP = useClientIP();

  const {
    selectedOrderType,
    setSelectedOrderType,
    selectedWaiterTables,
    setSelectedWaiterTables,
    selectedWaiters,
    setSelectedWaiters,
    cashTendered,
    setCashTendered,
    advanceAmount,
    setAdvanceAmount,
    shippingCharge,
    adjustment,
    grossAmount,
    setGrossAmount,
    discountedTotal,
    setDiscountedTotal,
    table1Data,
    setTable1Data,
    table2Data,
    setTable2Data,
    table3Data,
    setTable3Data,
    discountValue,
    calculateItemTotal,
    setShippingCharge,
    deliveryDate,
    setDeliveryDate,
    deliveryTime,
    setAdjustment,
    setDiscountValue,
    responseValues,
    setResponseValues,
    totalAmountBank,
    voucherTotalAmount,
    orderDetails,
    setOrderDetails,
    orderBillDetails,
    setOrderBillDetails,
    officerName,
    setOfficerName,
    selectedAddons,
    setSelectedAddons,
    addonsData,
    setAddonsData,
    formData,
    setFormData,
    cardTotalAmount,
    slipTotalAmount,
    chequeTotalAmount,
  } = useContext(CashierContext);

  // const [selectedOrderType, setSelectedOrderType] = useState("");
  const [orderTypes, setOrderTypes] = useState([]);
  // const [selectedWaiterTables, setSelectedWaiterTables] = useState("");
  const [waiterTables, setWaiterTables] = useState([]);
  // const [selectedWaiters, setSelectedWaiters] = useState("");
  const [waiters, setWaiters] = useState([]);
  const [selectedRooms, setSelectedRooms] = useState("");
  const [rooms, setRooms] = useState([]);
  const [error, setError] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [quantity, setQuantity] = useState({});
  const cartItems = useSelector((state) => state.cashierCart.items);
  console.log("cartItems", cartItems);
  const [billExpanded, setBillExpanded] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const location = useLocation();
  // const [placedOrderDetails, setPlacedOrderDetails] = useState(
  //   location.state?.placedOrderDetails || []
  // );
  const { ordercode } = location.state || {};
  console.log("ordercode", ordercode);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [isDialogOpen, setDialogOpen] = useState(false); // Control dialog visibility
  const [currentItem, setCurrentItem] = useState(null); // Track item for which addons are opened
  const cardList = useSelector((state) => state.cards.cardList);
  const chequeList = useSelector((state) => state.cheques.chequeList);
  const slipList = useSelector((state) => state.slips.slipList);
  const voucherList = useSelector((state) => state.vouchers.voucherList);
  const loyaltyData = useSelector((state) => state.loyalty.loyaltyData);
  const guestRefCode =
    loyaltyData?.Table2?.[0]?.GUESTREFCODE || CON_GUEST_REF_CODE;

  useEffect(() => {
    if (ordercode) {
      fetchOrderDetails(ordercode); // Fetch data when ordercode is available
      fetchOrderBillDetails(ordercode);
    }
  }, [ordercode]); // Run whenever ordercode changes

  // useEffect(() => {
  //   fetchOrderBillDetails(ordercode);
  // }, [ordercode]);

  useEffect(() => {
    fetchOrderTypes();
    fetchWaiterTables();
    fetchWaiters();
    fetchRooms();
  }, []);

  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, CATTYPE, USERNAME } =
    SYS_USER.USER_PARAM || {};

  // Handlers start

  const handleWaiterChange = (e) => {
    const selectedID = e.target.value; // Selected waiter ID
    setSelectedWaiters(selectedID);

    // Find the name of the selected waiter
    const selectedWaiter = waiters.find((waiter) => waiter.IDNO === selectedID);
    setOfficerName(selectedWaiter?.NAME || ""); // Set the name or default to empty string
  };
  // Handler for advance amount change
  const handleAdvanceAmountChange = (e) => {
    let input = e.target.value;

    // Allow only valid decimal inputs with up to 2 decimal places
    if (/^\d*\.?\d{0,2}$/.test(input)) {
      // Remove leading zero unless followed by a decimal point
      if (input.startsWith("0") && input[1] !== ".") {
        input = input.slice(1);
      }
      setAdvanceAmount(input);
    }
  };

  // Handler for cash tendered change
  const handleCashTenderedChange = (e) => {
    let input = e.target.value;

    // Allow only valid decimal inputs with up to 2 decimal places
    if (/^\d*\.?\d{0,2}$/.test(input)) {
      // Remove leading zero unless followed by a decimal point
      if (input.startsWith("0") && input[1] !== ".") {
        input = input.slice(1);
      }
      setCashTendered(input);
    }
  };

  const handleToggleBill = () => {
    setBillExpanded((prev) => !prev);
  };
  const handleRemoveFromCart = (itemId) => {
    dispatch(removeCashierItemFromCart(itemId));
  };

  // Filtered items based on the search query
  const filteredItems = [
    ...(Array.isArray(orderDetails.items) ? orderDetails.items : []), // Placed order details
    ...(Array.isArray(cartItems) ? cartItems : []), // Cart items
  ].filter(
    (item) =>
      item.MENUNAME.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.MENUREFCODE.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleClearSearch = () => {
    setSearchQuery("");
  };

  useEffect(() => {
    // Initialize quantities and recalculate totals whenever cartItems change
    const initialQuantities = {};
    cartItems.forEach((item) => {
      initialQuantities[item.KOTSEQCODE] = item.quantity || 1;
    });
    setQuantity(initialQuantities);
    calculateAndSetTotals(cartItems);
  }, [cartItems]);

  const handleQuantityChange = (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    setQuantity((prev) => ({
      ...prev,
      [itemId]: newQuantity,
    }));
    dispatch(updateCashierItemQuantity({ itemId, quantity: newQuantity }));
  };
  const handleClearCart = () => {
    dispatch(clearCashierCart());
    // setPlacedOrderDetails([]);
    setCashTendered(0);
    setAdvanceAmount(0);
    setDiscountedTotal(0);
    setShippingCharge(0);
    setAdjustment(0);
    setDiscountValue(0);
    setSelectedOrderType(
      orderTypes.length > 0 ? orderTypes[0].ORDERTYPECODE : null
    );
    setSelectedWaiterTables();
    setSelectedWaiters();
    setOrderDetails({ items: [] });

    setOrderBillDetails({ items: [] });
    dispatch(resetVouchers());
    dispatch(resetCreditNote());
    dispatch(clearSlips());
    dispatch(clearCheque());
    dispatch(resetCards());
    setResponseValues({
      advance: 0,
      afterCharge: 0,
      balance: 0,
      bank: 0,
      cash: 0,
      cashpaid: 0,
      charge: 0,
      discount: 0,
      gift: 0,
      gross: 0,
      loyalty: 0,
      nettGross: 0,
      refundAmt: 0,
      shipping: 0,
      tax: 0,
      totNett: 0,
      totPaid: 0,
    });
    setGrossAmount(0);
    navigate(location.pathname, { state: null });
  };

  function formatPrice(value) {
    if (typeof value === "number") {
      return value
        .toFixed(2) // Ensure two decimal places
        .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Add thousand separators
    }
    return value;
  }

  const setVoucherData = (voucherDetails) => {
    setFormData((prevData) => ({
      ...prevData,
      redeem: {
        ...prevData.redeem,
        voucher: voucherDetails,
      },
    }));
  };

  const calculateAndSetTotals = (items) => {
    let newTotals = {
      afterchargeamt: 0,
      netgrossamt: 0,
      netamt: 0,
      advanceamt: 0,
      shipping: 0,
    };
    items.forEach((item) => {
      newTotals.netgrossamt += item.RATE * item.quantity;
      // Assuming tax and other charges are applied based on your backend logic
    });
    newTotals.afterchargeamt = newTotals.netgrossamt + newTotals.shipping; // Example calculation
    // setTotals(newTotals);
  };

  const handleOrderTypeChange = (event) => {
    setSelectedOrderType(event.target.value);
  };

  const handleRoomChange = (event) => {
    setSelectedRooms(event.target.value);
  };

  const formattedDeliveryTime = deliveryTime
    ? deliveryTime.format("HH:mm:ss")
    : "";

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const grossAmountRef = useRef(grossAmount); // Ref to store the latest grossAmount

  useEffect(() => {
    // Update ref whenever grossAmount changes
    grossAmountRef.current = grossAmount;
  }, [grossAmount]);

  const calculateGrossAmount = () => {
    // Ensure orderBillDetails.items is valid
    const orderItems = orderBillDetails?.items || [];

    // Calculate the gross amount from cart items
    let totalGross = cartItems.reduce((total, item) => {
      // Base item total
      const itemTotal = item.RATE * item.quantity;

      // Addons total for the item
      const addonsTotal = (item.addons || []).reduce((addonTotal, addon) => {
        return addonTotal + addon.RATE * item.quantity; // Multiply addon price by the item's quantity
      }, 0);

      // Add item total and addons total to the total gross amount
      return total + itemTotal + addonsTotal;
    }, 0);

    // Check if GROSSAMOUNT is available and valid in orderBillDetails
    const orderGrossAmount = orderItems[0]?.GROSSAMOUNT;
    if (orderGrossAmount && !isNaN(orderGrossAmount)) {
      totalGross += orderGrossAmount; // Add GROSSAMOUNT to the total gross
    } else {
      console.warn("GROSSAMOUNT is not available or is invalid.");
    }

    return totalGross;
  };

  const ValidatePayConfirmation = () => {
    try {
      var isValid = true;
      if (responseValues.balance < 0) {
        isValid = false;
      }
      return isValid;
    } catch {
      setSnackbarMessage("Error processing payment.");
      setSnackbarOpen(true);
      return false;
    }
  };

  // Call this function in the `useEffect` as you already have.

  const redeemAmountFromRedux = useSelector(
    (state) => state.loyalty.redeemAmount
  );
  const creditNotePaymentAmount = useSelector(selectCreditNotePaymentAmount);
  const claimedCreditNote = useSelector(selectClaimedCreditNote);
  useEffect(() => {
    const totalGross = calculateGrossAmount();

    // Only update if the grossAmount has changed
    if (totalGross !== grossAmount) {
      setGrossAmount(totalGross); // Update the grossAmount state
    }
  }, [cartItems, filteredItems, orderBillDetails]);

  const totalUniqueItems = filteredItems.length; // Count of unique items
  const totalQuantity = filteredItems.reduce((total, item) => {
    const itemQuantity =
      quantity[item.KOTSEQCODE] || item.QTY || item.quantity || 1;
    return total + itemQuantity;
  }, 0);

  const handleAddonSelection = (e, addon) => {
    if (e.target.checked) {
      setSelectedAddons((prev) => [...prev, addon]);
    } else {
      setSelectedAddons((prev) =>
        prev.filter((sel) => sel.ADDONCODE !== addon.ADDONCODE)
      );
    }
  };

  const handleSaveAddons = () => {
    if (currentItem) {
      dispatch(
        updateItemAddons({
          KOTSEQCODE: currentItem.KOTSEQCODE,
          addons: selectedAddons,
        })
      );
      console.log("Saved addons for item:", currentItem.KOTSEQCODE);
    }
    setDialogOpen(false);
    setSelectedAddons([]);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setCurrentItem(item);
  };
  // Handlers end

  // API calls start
  const fetchOrderDetails = async (orderCode) => {
    try {
      const response = await externalgetApi(CASHIER_API_02, "GET", {
        ORDERCODE: orderCode,
        STS: CON_STATUS_ACTIVE,
        STSR: CON_STATUS_RETURN,
      });

      setOrderDetails({ items: response }); // Set the fetched order details to state
      console.log("response CASHIER_API_02", response);
    } catch (error) {
      setError(error);
      console.error("Error fetching order details:", error);
    }
  };

  const fetchOrderBillDetails = async (orderCode) => {
    try {
      const response = await externalgetApi(CASHIER_API_06, "GET", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        ORDERCODE: orderCode,
        STS: CON_STATUS_PENDING,
      });

      console.log("response CASHIER_API_06 plcd summery", response);

      if (response?.length > 0) {
        setOrderBillDetails({ items: response });
        if (response?.length > 0 && response[0]?.ORDERTYPECODE) {
          setSelectedOrderType(response[0]?.ORDERTYPECODE);
        }

        // Update GROSSAMOUNT only if it's valid
        const grossAmountFromResponse = response[0]?.GROSSAMOUNT || 0;
        if (grossAmountFromResponse && !isNaN(grossAmountFromResponse)) {
          setGrossAmount(grossAmountFromResponse);
        } else {
          console.warn("Invalid GROSSAMOUNT in response.");
        }
      }
    } catch (error) {
      setError(error);
    }
  };

  const fetchOrderTypes = async () => {
    try {
      const params = {
        CATTYPE,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(COMMON_API_01, "GET", params);

      setOrderTypes(response);
      setDataLoaded(true);

      // Set the default OrderType as the first one in the list
      if (response.length > 0) {
        const defaultOrderType = response[0].ORDERTYPECODE;

        // Set the default to the first OrderType if no specific one is selected
        setSelectedOrderType((prev) => prev || defaultOrderType);

        // Fetch order bill details with the default or selected OrderType
        //fetchOrderBillDetails(defaultOrderType);
      }
    } catch (error) {
      console.error("Error fetching order types:", error);
      setError(error);
    } finally {
      setDataLoaded(true);
    }
  };

  const fetchWaiterTables = async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
      };

      const response = await externalgetApi(COMMON_API_03, "GET", params);

      setWaiterTables(response);
      setDataLoaded(true);
    } catch (error) {
      console.error("Error fetching Waiters:", error);
      setError(error);
    } finally {
      setDataLoaded(true);
    }
  };

  const fetchAddons = async (item) => {
    try {
      setLoading(true);
      setCurrentItem(item); // Track the specific cart item

      const params = { COMPCODE, LOCCODE, RESTCODE, STS: CON_STATUS_ACTIVE };
      const response = await externalgetApi(SETTINGS_API_07, "GET", params);

      console.log("Fetched addons:", response);
      setAddonsData(response || []);

      // Load previously selected addons for the current item
      setSelectedAddons(item.addons || []);
      setDialogOpen(true);
    } catch (error) {
      console.error("Error fetching Addons:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchWaiters = async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
      };

      const response = await externalgetApi(SETTINGS_API_06, "GET", params);

      setWaiters(response);
      setDataLoaded(true);
    } catch (error) {
      console.error("Error fetching Waiters:", error);
      setError(error);
    } finally {
      setDataLoaded(true);
    }
  };

  const fetchRooms = async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE,
        STS: CON_STATUS_ACTIVE,
      };

      const response = await externalgetApi(COMMON_API_06, "GET", params);

      setRooms(response);
      setDataLoaded(true);
    } catch (error) {
      console.error("Error fetching Waiters:", error);
      setError(error);
    } finally {
      setDataLoaded(true);
    }
  };

  const handlePlaceOrder = async () => {
    setLoading(true);

    // Combine items from orderDetails and cartItems
    const activeOrderDetailsItems = (orderDetails.items || []).map((item) => ({
      ...item,
      sts: CON_STATUS_PENDING,
    }));

    const pendingCartItems = (cartItems || []).map((item) => ({
      ...item,
      sts: CON_STATUS_PENDING,
    }));

    const combinedItems = [...activeOrderDetailsItems, ...pendingCartItems];
    if (!combinedItems || combinedItems.length === 0) {
      setSnackbarMessage(MSG_EMPTY_CART);
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return; // Exit early
    }

    const dtDetail = combinedItems.flatMap((item, index) => {
      // Main item
      const mainItem = {
        kotseqcode: index + 1,
        addoncode: CON_ADDON_CODE, // Default addon code for main item
        menucatcode: String(item.MENUCATCODE),
        menucode: String(item.MENUCODE),
        qty: item.quantity || item.QTY || 1,
        rate: parseFloat(item.RATE || item.RATE || 0),
        amount: parseFloat(calculateItemTotal(item).toFixed(2)),
        remark: String(item.REMARK || ""),
        isaddon: CON_IS_ADDON, // Main item flag
        sts: item.sts,
      };

      // Addon items
      const addonItems = (item.addons || []).map((addon) => ({
        kotseqcode: index + 1, // Same sequence as the parent item
        addoncode: String(addon.ADDONCODE), // Unique addon code
        menucatcode: String(item.MENUCATCODE), // Parent's category code
        menucode: String(item.MENUCODE), // Parent's menu code
        qty: item.quantity || item.QTY || 1, // Match parent item quantity
        rate: parseFloat(addon.RATE || 0),
        amount: parseFloat((addon.RATE * (item.quantity || 1)).toFixed(2)), // Total for addon
        remark: addon.DESCRIP || "", // Addon's description
        isaddon: CON_IS_ADDON_YES, // Addon flag
        // sts: addon.sts || CON_STATUS_PENDING,
        sts: item.sts,
      }));

      // Combine main item and its addons
      return [mainItem, ...addonItems];
    });

    const dtTax =
      Array.isArray(table2Data) && table2Data.length > 0
        ? table2Data.map((taxItem) => ({
            taxpgcode: taxItem.TAXPAGECODE ? String(taxItem.TAXPAGECODE) : "0", // default to "0" if empty
            compcode: taxItem.COMPCODE ? String(taxItem.COMPCODE) : "0", // default to "0" if empty
            loccode: taxItem.LOCCODE ? String(taxItem.LOCCODE) : "0", // default to "0.00" if empty
            taxcode: taxItem.TAXCODE ? String(taxItem.TAXCODE) : "0",
            taxrate: taxItem.TAXRATE || 0,
            amount: taxItem.TAXAMOUNT || 0, // default to "0.00" if empty
          }))
        : [
            // If no data exists, send a single item with default empty values
            {
              taxpgcode: "0", // default empty value
              compcode: "0", // default empty value
              loccode: "0", // default empty value
              taxcode: "0",
              taxrate: 0,
              amount: 0,
            },
          ];

    const dtCharges =
      Array.isArray(table3Data) && table3Data.length > 0
        ? table3Data.map((chargeItem) => ({
            ordertypecode: chargeItem.ORDERTYPECODE
              ? String(chargeItem.ORDERTYPECODE)
              : "0", // default to "0" if empty
            chargecode: chargeItem.CHARGECODE
              ? String(chargeItem.CHARGECODE)
              : "0", // default to "0" if empty
            chargerate: chargeItem.CHARGERATE || 0, // default to "0.00" if empty
            amount: chargeItem.CHARGEAMOUNT || 0, // default to "0.00" if empty
          }))
        : [
            // If no data exists, send a single item with default empty values
            {
              ordertypecode: "0", // default empty value
              chargecode: "0", // default empty value
              chargerate: 0, // default empty value
              amount: 0, // default empty value
            },
          ];
    // const isPlaceOrder = orderDetails && orderDetails.length > 0;
    const isPlaceOrder = orderDetails?.items?.length > 0;

    const payload = {
      dtDetail,
      dtTax,
      dtCharges,

      dtPay: [
        {
          paymode: CON_EMPTY_VALUE,
          clientname: CON_EMPTY_VALUE,
          refno: CON_EMPTY_VALUE,
          bank: CON_EMPTY_VALUE,
          branch: CON_EMPTY_VALUE,
          amount: CON_VALUE_ZERO,
        },
      ],

      dtVoucher: [
        {
          refcode: CON_EMPTY_VALUE,
          vouchercode: CON_EMPTY_VALUE,
          voucherno: CON_EMPTY_VALUE,
          barcode: CON_EMPTY_VALUE,
          amount: CON_VALUE_ZERO,
        },
      ],

      // Main Order Data
      compcode: COMPCODE,
      loccode: LOCCODE,
      restcode: RESTCODE,
      ordercode: ordercode ? String(ordercode) : CON_EMPTY_VALUE,
      guestordercode: CON_EMPTY_VALUE,
      terminalcode: clientIP,
      paymentcode: CON_EMPTY_VALUE,
      guestrefcode: String(guestRefCode) || CON_GUEST_REF_CODE,
      tablecode: selectedWaiterTables ? selectedWaiterTables.toString() : "",
      orderendate: new Date().toISOString().split("T")[0],
      deliverydate: String(deliveryDate),
      deliverytime: formattedDeliveryTime,
      billamount: table1Data.TOTNETT || CON_VALUE_ZERO,
      discount: table1Data.DISCOUNT || CON_VALUE_ZERO,
      paidamount: table1Data.TOTPAID || CON_VALUE_ZERO,
      advanceamount: advanceAmount || 0,
      shippingamount: CON_VALUE_ZERO_ST,
      balanceamount: CON_VALUE_ZERO_ST,
      remark: CON_EMPTY_VALUE,
      ordersts: CON_STATUS_PENDING,
      orderdetsts: CON_STATUS_PENDING,
      paymentsts: CON_STATUS_PENDING,
      deliverysts: CON_DELIVERY_STS,
      officername: String(officerName),
      enuser: String(USERNAME),
      locdate: new Date().toISOString().split("T")[0],
      roomnocode: selectedRooms ? selectedRooms.toString() : "",
      ordertype: selectedOrderType ? selectedOrderType.toString() : "",
      iscashier: CON_IS_CASHIER_YES,
      paymode: CON_EMPTY_VALUE,
      paydate: new Date().toISOString().split("T")[0],
      grossamount: String(grossAmount),
      giftamount: CON_VALUE_ZERO_ST,
      loyaltyamount: CON_VALUE_ZERO_ST,
      taxamount: String(table1Data.TAX) || CON_VALUE_ZERO_ST,
      cashamount: CON_VALUE_ZERO_ST,
      chequeamount: CON_VALUE_ZERO_ST,
      slipamount: CON_VALUE_ZERO_ST,
      cardamount: CON_VALUE_ZERO_ST,
      discountrate: CON_VALUE_ZERO_ST,
      creditdueamount: CON_VALUE_ZERO_ST,
      adjustamount: CON_VALUE_ZERO_ST,
      iscredit: CON_IS_CREDIT_NO,
      isPlaceOrder,
      ipaddress: clientIP,
    };
    console.log("Order placed payload:", payload);
    try {
      const response = await externalpostApi(ORDER_API_05, payload);
      console.log("Order placed successfully:", response);
      const orderCode = response;

      if (!orderCode) {
        throw new Error("Order code not received from the API.");
      }
      navigate("/OrderSuccessMobile", {
        state: {
          source: "CashierSummeryMobile",
          snackbarMessage: MSG_CASHIER_SUCCESS,
          snackbarSeverity: "success",
          orderPayload: payload,
          orderCode: orderCode,
        },
      });

      setSnackbarMessage(MSG_CASHIER_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      dispatch(clearCashierCart());
      setCashTendered(0);
    } catch (error) {
      console.error("Error placing order:", error);

      setSnackbarMessage(MSG_CASHIER_FAILED);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmOrder = async () => {
    if (!ValidatePayConfirmation()) {
      setSnackbarMessage("Payment Failed. Insufficient funds to pay the bill.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const resolvedCashAmount = resolveCashAmountForOrderPost({
      cashTendered,
      formDataCashAmount: formData?.cash?.amount,
      totNett: table1Data.TOTNETT,
      advanceAmount,
      creditNoteAmount: creditNotePaymentAmount,
      giftAmount: voucherTotalAmount,
      loyaltyAmount: redeemAmountFromRedux,
      cardAmount: cardTotalAmount,
      chequeAmount: chequeTotalAmount,
      slipAmount: slipTotalAmount,
    });

    const dtPay = [];
    const dtVoucher = [];
    // const dtVoucher = [];

    // const combinedItems = [
    //   ...(Array.isArray(orderDetails.items) ? orderDetails.items : []),
    //   ...(Array.isArray(cartItems) ? cartItems : []),
    // ];

    // Combine items from orderDetails and cartItems
    const activeOrderDetailsItems = (orderDetails.items || []).map((item) => ({
      ...item,
      sts: CON_STATUS_ACTIVE,
    }));

    const pendingCartItems = (cartItems || []).map((item) => ({
      ...item,
      sts: CON_STATUS_PENDING,
    }));

    const combinedItems = [...activeOrderDetailsItems, ...pendingCartItems];
    if (!combinedItems || combinedItems.length === 0) {
      setSnackbarMessage(MSG_EMPTY_CART);
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return; // Exit early
    }

    const dtDetail = combinedItems.flatMap((item, index) => {
      // Main item
      const mainItem = {
        kotseqcode: index + 1,
        addoncode: CON_ADDON_CODE, // Default addon code for main item
        menucatcode: String(item.MENUCATCODE),
        menucode: String(item.MENUCODE),
        qty: item.quantity || item.QTY || 1,
        rate: parseFloat(item.ITEMRATE || item.RATE || 0),
        amount: parseFloat(calculateItemTotal(item).toFixed(2)),
        remark: String(item.REMARK || ""),
        isaddon: CON_IS_ADDON, // Main item flag
        sts: item.sts,
      };

      // Addon items
      const addonItems = (item.addons || []).map((addon) => ({
        kotseqcode: index + 1, // Same sequence as the parent item
        addoncode: String(addon.ADDONCODE), // Unique addon code
        menucatcode: String(item.MENUCATCODE), // Parent's category code
        menucode: String(item.MENUCODE), // Parent's menu code
        qty: item.quantity || item.QTY || 1, // Match parent item quantity
        rate: parseFloat(addon.RATE || 0),
        amount: parseFloat((addon.RATE * (item.quantity || 1)).toFixed(2)), // Total for addon
        remark: addon.DESCRIP || "", // Addon's description
        isaddon: CON_IS_ADDON_YES, // Addon flag
        sts: item.sts, // Addon status
      }));

      // Combine main item and its addons
      return [mainItem, ...addonItems];
    });

    if (formData.cash?.amount) {
      dtPay.push({
        paymode: "CA", // Paymode for Cash
        clientname: formData.cash.clientname || "",
        refno: formData.cash.refno || "",
        bank: "",
        branch: "",
        amount: formData.cash.amount,
      });
    } else if (resolvedCashAmount > 0) {
      dtPay.push({
        paymode: "CA",
        clientname: "",
        refno: "",
        bank: "",
        branch: "",
        amount: resolvedCashAmount,
      });
    }

    // Handle Card Payment
    // Process card payments from Redux
    cardList.forEach((card) => {
      if (card.cardamount) {
        dtPay.push({
          paymode: "VS",
          clientname: card.cardname || "",
          refno: card.cardaccountNumber || "",
          bank: card.cardbank || "",
          branch: card.cardbranch || "",
          amount: card.cardamount || 0,
        });
      }
    });

    // Process sliplist payments from Redux
    slipList.forEach((slip) => {
      if (slip?.slipamount) {
        dtPay.push({
          paymode: "OS",
          clientname: slip.slipname || "",
          refno: "0",
          bank: slip.slipbank || "",
          branch: slip.slipbranch || "",
          amount: slip.slipamount || 0,
        });
      }
    });

    // Process chequeList payments from Redux
    chequeList.forEach((cheque) => {
      if (cheque?.chequeamount) {
        dtPay.push({
          paymode: "CP",
          clientname: cheque.chequename || "",
          refno: "0",
          bank: cheque.chequebank || "",
          branch: cheque.chequebranch || "",
          amount: cheque.chequeamount || 0,
        });
      }
    });

    // Ensure at least one empty payment object is included if no payments are added
    const dtPayParam =
      dtPay.length > 0
        ? dtPay
        : [
            {
              paymode: "0",
              clientname: "0",
              refno: "0",
              bank: "0",
              branch: "0",
              amount: 0,
            },
          ];

    // Handle Redeem (Loyalty and Voucher)
    // if (
    //   formData.redeem?.loyalty?.chequeamount !== null &&
    //   formData.redeem?.loyalty?.chequeamount !== undefined
    // ) {
    if (formData.redeem?.loyalty?.amount) {
      dtPay.push({
        paymode: "LOYALTY",
        clientname: formData.redeem.loyalty.clientname || "",
        refno: "",
        bank: "",
        branch: "",
        amount: formData.redeem.loyalty.amount,
      });
    }

    // Process chequeList payments from Redux
    voucherList.forEach((voucher) => {
      if (voucher?.voucheramount) {
        dtVoucher.push({
          refcode: String(voucher.voucherrefcode) || "",
          vouchercode: String(voucher.vouchercode) || "",
          voucherno: voucher.voucherno || "",
          barcode: voucher.voucherbarcode || "",

          amount: voucher.voucheramount || 0,
        });
      }
    });

    const dtVoucherParam =
      dtVoucher.length > 0
        ? dtVoucher
        : [
            {
              refcode: "0",
              vouchercode: "0",
              voucherno: "0",
              barcode: "0",
              amount: 0,
            },
          ];

    // Map over table2 to create dtTax entries
    const dtTax =
      Array.isArray(table2Data) && table2Data.length > 0
        ? table2Data.map((taxItem) => ({
            taxpgcode: taxItem.TAXPAGECODE ? String(taxItem.TAXPAGECODE) : "0", // default to "0" if empty
            compcode: taxItem.COMPCODE ? String(taxItem.COMPCODE) : "0", // default to "0" if empty
            loccode: taxItem.LOCCODE ? String(taxItem.LOCCODE) : "0", // default to "0.00" if empty
            taxcode: taxItem.TAXCODE ? String(taxItem.TAXCODE) : "0",
            taxrate: taxItem.TAXRATE || 0,
            amount: taxItem.TAXAMOUNT || 0, // default to "0.00" if empty
          }))
        : [
            // If no data exists, send a single item with default empty values
            {
              taxpgcode: "0", // default empty value
              compcode: "0", // default empty value
              loccode: "0", // default empty value
              taxcode: "0",
              taxrate: 0,
              amount: 0,
            },
          ];

    // Map over table3Data to create dtTax entries
    const dtCharges =
      Array.isArray(table3Data) && table3Data.length > 0
        ? table3Data.map((chargeItem) => ({
            ordertypecode: chargeItem.ORDERTYPECODE
              ? String(chargeItem.ORDERTYPECODE)
              : "0", // default to "0" if empty
            chargecode: chargeItem.CHARGECODE
              ? String(chargeItem.CHARGECODE)
              : "0", // default to "0" if empty
            chargerate: chargeItem.CHARGERATE || 0, // default to "0.00" if empty
            amount: chargeItem.CHARGEAMOUNT || 0, // default to "0.00" if empty
          }))
        : [
            // If no data exists, send a single item with default empty values
            {
              ordertypecode: "0", // default empty value
              chargecode: "0", // default empty value
              chargerate: 0, // default empty value
              amount: 0, // default empty value
            },
          ];
    const isPlaceOrder = orderDetails?.items?.length > 0;
    const dtrefunddetParam = buildDtRefundDetParam(
      claimedCreditNote,
      creditNotePaymentAmount
    );
    const payload = {
      dtDetail,
      dtTax,
      dtCharges,
      dtPay: dtPayParam,
      dtVoucher: dtVoucherParam,
      dtrefunddet: dtrefunddetParam,
      compcode: COMPCODE,
      loccode: LOCCODE,
      restcode: RESTCODE,
      ordercode: ordercode ? String(ordercode) : CON_EMPTY_VALUE, // Provide the order code if available
      guestordercode: CON_EMPTY_VALUE, // Optional guest order code
      terminalcode: clientIP, // Set the terminal code if required
      paymentcode: CON_EMPTY_VALUE, // Provide if necessary
      guestrefcode: String(guestRefCode) || CON_GUEST_REF_CODE,
      tablecode: selectedWaiterTables ? selectedWaiterTables.toString() : "",
      orderendate: new Date().toISOString().split("T")[0],
      deliverydate: String(deliveryDate),
      deliverytime: formattedDeliveryTime,
      billamount: table1Data.TOTNETT || CON_VALUE_ZERO,
      discount: table1Data.DISCOUNT || CON_VALUE_ZERO,
      paidamount: table1Data.TOTPAID || CON_VALUE_ZERO,
      advanceamount: advanceAmount || 0,
      shippingamount: shippingCharge || 0,
      balanceamount: String(responseValues.balance) || CON_VALUE_ZERO_ST,
      remark: CON_EMPTY_VALUE,
      ordersts: CON_STATUS_ACTIVE,
      orderdetsts: CON_STATUS_ACTIVE,
      paymentsts: CON_STATUS_ACTIVE,
      deliverysts: CON_DELIVERY_STS,
      officername: String(officerName),
      enuser: String(USERNAME),
      locdate: new Date().toISOString().split("T")[0],
      roomnocode: "",
      ordertype: selectedOrderType ? selectedOrderType.toString() : "",
      iscashier: CON_IS_CASHIER_YES,
      paymode: CON_EMPTY_VALUE, // Main paymode if needed
      paydate: new Date().toISOString().split("T")[0],
      grossamount: String(grossAmount),
      giftamount: String(voucherTotalAmount) || CON_VALUE_ZERO_ST,
      loyaltyamount: String(redeemAmountFromRedux) || "0",
      taxamount: String(table1Data.TAX) || CON_VALUE_ZERO_ST,
      cashamount: String(resolvedCashAmount),
      chequeamount: String(chequeTotalAmount || 0),
      slipamount: String(slipTotalAmount || 0),
      cardamount: String(cardTotalAmount || 0),
      CENOTEAMOUNT: String(creditNotePaymentAmount) || CON_VALUE_ZERO_ST,
      discountrate: String(discountedTotal) || CON_VALUE_ZERO_ST,
      creditdueamount: CON_VALUE_ZERO_ST,
      adjustamount: String(adjustment),
      iscredit: "N",
      // isplacedorder: false,
      isPlaceOrder,
      ipaddress: clientIP,
    };

    try {
      const response = await externalpostApi(ORDER_API_07, payload);
      console.log("order confirm", response);
      const orderCode = response;
      persistCeNoteReturnType(
        orderCode,
        claimedCreditNote?.returnTypeCode,
        creditNotePaymentAmount
      );
      setSnackbarMessage("Order placed successfully!");
      setSnackbarOpen(true);
      navigate("/OrderSuccessMobile", {
        state: {
          source: "CashierPaymentMobile",
          snackbarMessage: MSG_CASHIER_SUCCESS,
          snackbarSeverity: "success",
          orderPayload: payload,
          orderCode: orderCode,
          table1Data,
        },
      });

      setSnackbarMessage(MSG_CASHIER_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      // dispatch(clearCashierCart());

      // sessionStorage.clear();

      // setFormData();
      // Optionally clear Redux state or reset relevant components
      setFormData("");
      setCashTendered(0);
      setAdvanceAmount(0);
      setDiscountedTotal(0);
      setShippingCharge(0);
      setAdjustment(0);
      setDiscountValue(0);

      // Alternatively, remove specific keys
      sessionStorage.removeItem("cardList");
      sessionStorage.removeItem("chequeList");
      sessionStorage.removeItem("slipList");

      dispatch(setVoucherData([]));
      dispatch(clearCashierCart());
      dispatch(setRedeemAmount(""));
      dispatch(resetCards());
      dispatch(clearLoyaltyData());
      dispatch(resetCreditNote());
    } catch (error) {
      console.error("Error placing order:", error);
      setSnackbarMessage("Failed to place order.");
      setSnackbarOpen(true);
    }
  };

  useMemo(() => {
    const handleOrderCalculation = async () => {
      // Prepare the payload with all required values
      console.log("grossAmount for place", grossAmount);
      if (grossAmount > 0) {
        const advanceAmountFromBillDetails =
          orderBillDetails?.items.length > 0 &&
          orderBillDetails?.items[0]?.ADVANCEAMOUNT
            ? orderBillDetails?.items[0]?.ADVANCEAMOUNT
            : advanceAmount;

        // const advanceAmountFromBillDetails =
        //   orderBillDetails?.items?.[0]?.ADVANCEAMOUNT || advanceAmount || 0;
        console.log(
          "advanceAmountFromBillDetails for place",
          advanceAmountFromBillDetails
        );
        setAdvanceAmount(advanceAmountFromBillDetails);
        const payload = {
          taxpagecode: CON_TAX_PAGE_CODE,
          compcode: COMPCODE,
          loccode: LOCCODE,
          restcode: RESTCODE,
          ordertype: selectedOrderType ? selectedOrderType.toString() : "",
          gross: parseFloat(grossAmount) || 0, // Backend value
          adjustment: parseFloat(adjustment) || 0, // You can set this to the calculated adjustment if needed
          totbank: parseFloat(totalAmountBank) || 0, // You can set this based on the required calculation
          discountrate: discountValue || 0, // Same for discount rate if applicable
          totgift: parseFloat(voucherTotalAmount) || 0,
          totloyalty: parseFloat(redeemAmountFromRedux) || 0, // Same for loyalty points
          totcash: parseFloat(cashTendered) || 0, // User input value
          shipping: parseFloat(shippingCharge) || 0, // If there's a shipping charge, set here
          advance: parseFloat(advanceAmountFromBillDetails) || 0, // User input value
          refundamt: creditNotePaymentAmount,
        };
        console.log("payload pos bill", payload);
        try {
          // Call your external API
          const response = await externalpostApi(ORDER_API_09, payload);
          console.log("balnce ", response);

          // if (response && response.Table1 && response.Table2 && response.Table3) {

          if (response?.Table1 && response?.Table2 && response?.Table3) {
            setTable1Data(response?.Table1[0] || {});
            setTable2Data(response?.Table2 || []);
            setTable3Data(response?.Table3 || []);

            setResponseValues({
              advance: response.Table1[0]?.ADVANCE || 0,
              afterCharge: response.Table1[0]?.AFTERCHARGE || 0,
              balance: response.Table1[0]?.BALANCE || 0,
              bank: response.Table1[0]?.BANK || 0,
              cash: response.Table1[0]?.CASH || 0,
              cashpaid: response.Table1[0]?.CASHAPID || 0,
              charge: response.Table1[0]?.CHARGE || 0,
              discount: response.Table1[0]?.DISCOUNT || 0,
              gift: response.Table1[0]?.GIFT || 0,
              gross: response.Table1[0]?.GROSS || 0,
              loyalty: response.Table1[0]?.LOYALTY || 0,
              nettGross: response.Table1[0]?.NETTGROSS || 0,
              refundAmt: response.Table1[0]?.REFUNDAMT || 0,
              shipping: response.Table1[0]?.SHIPPING || 0,
              tax: response.Table1[0]?.TAX || 0,
              totNett: response.Table1[0]?.TOTNETT || 0,
              totPaid: response.Table1[0]?.TOTPAID || 0,
            });
          } else {
            console.error(
              "Invalid response format: expected an array with an object."
            );
          }
        } catch (error) {
          console.error("Error calculating order:", error);
        }
      }
    };

    // Ensure handleOrderCalculation is triggered every time the relevant state changes
    handleOrderCalculation();
  }, [
    ordercode,
    grossAmount,
    advanceAmount,
    cashTendered,
    selectedOrderType,
    discountedTotal,
    discountValue,
    shippingCharge,
    adjustment,
    totalAmountBank,
    redeemAmountFromRedux,
    orderBillDetails,
    voucherTotalAmount,
    creditNotePaymentAmount,
  ]);

  const filteredBillValues = useMemo(() => {
    const displayItems = [];

    if (responseValues.bank > 0) {
      displayItems.push({
        description: "Bank",
        value: formatPrice(responseValues.bank),
      });
    }

    if (responseValues.gift > 0) {
      displayItems.push({
        description: "Gift",
        value: formatPrice(responseValues.gift),
      });
    }

    if (creditNotePaymentAmount > 0) {
      displayItems.push({
        description: getCashierCeNoteClaimedLabel(claimedCreditNote?.returnTypeCode),
        value: formatPrice(creditNotePaymentAmount),
      });
    }

    if (responseValues.loyalty > 0) {
      displayItems.push({
        description: "Loyalty",
        value: formatPrice(responseValues.loyalty),
      });
    }

    return displayItems;
  }, [
    responseValues.bank,
    responseValues.gift,
    responseValues.loyalty,
    creditNotePaymentAmount,
    claimedCreditNote?.returnTypeCode,
  ]);
  // API calls end

  return (
    <>
      <Grid
        spacing={0}
        sx={{ ...styles.m_aside_content, height: "82vh" }}
        id="xxxyyy"
      >
        <Box
          gap={1}
          // pt={2}
          display={"flex"}
          alignItems={"center"}
          // height={"5vh"}
        >
          <TextField
            id="outlined-search"
            placeholder="Item Name or Item Code"
            type="search"
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ width: "100%" }}
          />

          <IconButton
            size="small"
            sx={styles.cs_summary_refresh_icon}
            aria-label="clear search"
            onClick={handleClearSearch}
          >
            <CachedIcon />
          </IconButton>
        </Box>
        <Box pt={2}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextField
                id="outlined-select-currency-native"
                select
                label="Order Types"
                defaultValue=""
                size="small"
                fullWidth
                value={selectedOrderType || ""}
                onChange={handleOrderTypeChange}
                disabled={!dataLoaded}
              >
                {orderTypes.map((option) => (
                  <MenuItem
                    key={option.ORDERTYPECODE}
                    value={option.ORDERTYPECODE}
                  >
                    {option.ORDERTYPE}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <TextField
              id="outlined-select-table"
              select
              label="Table"
              defaultValue=""
              size="small"
              fullWidth
              value={selectedWaiterTables}
              onChange={(e) => setSelectedWaiterTables(e.target.value)}
              disabled={!dataLoaded}
            >
              {waiterTables.map((option) => (
                <MenuItem key={option.TABLECODE} value={option.TABLECODE}>
                  {option.TABLENAME}{" "}
                </MenuItem>
              ))}
            </TextField>
          </Grid> */}
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextField
              id="outlined-select-table"
              select
              label="Waiter"
              defaultValue=""
              size="small"
              fullWidth
              value={selectedWaiters}
              onChange={handleWaiterChange}
              disabled={!dataLoaded}
            >
              {waiters.map((option) => (
                <MenuItem key={option.IDNO} value={option.IDNO}>
                  {option.NAME}
                </MenuItem>
              ))}
            </TextField>
          </Grid> */}
            {/* {selectedOrderType === 4 && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextField
                id="outlined-select-room"
                select
                label="Room"
                defaultValue=""
                size="small"
                fullWidth
                value={selectedRooms}
                onChange={handleRoomChange}
                disabled={!dataLoaded}
              >
                {rooms.map((option) => (
                  <MenuItem key={option.ROOMNOCODE} value={option.ROOM}>
                    {option.ROOM}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )} */}
          </Grid>
        </Box>

        <Divider sx={{ color: "red", pt: 1 }} />

        <Box sx={styles.m_cs_summary_items_area}>
          {filteredItems.length === 0 ? (
            <Box
              alignContent={"center"}
              justifyItems={"center"}
              sx={{ color: theme.palette.text.icons }}
            >
              <ShoppingCartRoundedIcon />
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                  textAlign: "center",
                  mt: 4,
                }}
              >
                Your cart is empty. Add items from the store to begin your
                order!
              </Typography>
            </Box>
          ) : (
            filteredItems.map((item, index) => {
              // Check if item belongs to placed orders
              const isPlacedOrder = orderDetails.items.some(
                (placedItem) => placedItem.KOTSEQCODE === item.KOTSEQCODE
              );

              return (
                <Box
                  key={index}
                  sx={{ paddingTop: 1, overflow: "auto", padding: 1 }}
                >
                  <Grid container sx={styles.cs_summary_card_content}>
                    <Grid item xs={6}>
                      <Typography
                        sx={{
                          ...styles.cs_summary_card_name,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textWrap: "nowrap",
                        }}
                        component="div"
                      >
                        {item.MENUNAME}
                      </Typography>
                      <Typography sx={styles.cs_summary_card_item_price}>
                        {item.MENUREFCODE}
                      </Typography>
                      <Typography
                        sx={styles.cs_summary_card_total_price}
                        component="div"
                      >
                        {item.ITEMRATE && item.quantity
                          ? formatPrice(calculateItemTotal(item))
                          : formatPrice(item.AMOUNT)}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <TextField
                          type="number"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={quantity[item.KOTSEQCODE] || item.QTY || 1}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Restrict the input to numbers only and limit to 3 digits
                            if (/^\d{1,3}$/.test(value)) {
                              handleQuantityChange(
                                item.KOTSEQCODE,
                                parseInt(value, 10)
                              );
                            }
                          }}
                          InputProps={{ inputProps: { min: 1 } }}
                          disabled={isPlacedOrder}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={1} sx={styles.right_align}>
                      <IconButton
                        aria-label="add-on"
                        onClick={(e) => handleMenuOpen(e, item)}
                        // disabled={item.isPlacedOrder}
                        disabled={isPlacedOrder}
                        //  sx={styles.cs_summary_refresh_icon}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={
                          Boolean(anchorEl) &&
                          currentItem?.KOTSEQCODE === item.KOTSEQCODE
                        }
                        onClose={handleMenuClose}
                      >
                        <MenuItem
                          onClick={() => {
                            fetchAddons(item); // Your logic for fetching addons
                            handleMenuClose(); // Close the menu
                          }}
                        >
                          Addons
                        </MenuItem>
                      </Menu>
                    </Grid>
                    <Grid item xs={1} sx={styles.right_align}>
                      <IconButton
                        sx={styles.m_cs_cash_delete_icon}
                        aria-label="delete"
                        onClick={() => handleRemoveFromCart(item.KOTSEQCODE)}
                        disabled={isPlacedOrder}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Box>
              );
            })
          )}
        </Box>

        <Divider />
        {/* Bill Area start */}
        <Box
          sx={{
            height: "30vh",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              // top: "60vh",
              right: 0,
              padding: "2px 16px 16px 16px",
              background: theme.palette.input_field.fill,
              // zIndex: 1000,
              boxShadow: 4,
              // overflow: "auto",
            }}
          >
            <Grid item xs={12} sx={styles.text_center}>
              <IconButton
                onClick={handleToggleBill}
                sx={styles.summary_bill_expand_icon}
              >
                {billExpanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
              </IconButton>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Currency
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                LKR
              </Typography>
            </Grid>

            {[
              {
                description: "Line Items",
                value: `${totalUniqueItems} (Items ${totalQuantity})`,
              },
              ...(billExpanded
                ? [{ description: "Advance", input: true }]
                : []),
              { description: "Cash Tendered", input: true },
              ...(billExpanded
                ? [
                    {
                      description: "Gross",
                      value: formatPrice(responseValues.gross),
                    },
                    {
                      description: "Discount",
                      value: formatPrice(responseValues.discount),
                    },
                    {
                      description: "Tax",
                      value: formatPrice(responseValues.tax),
                    },
                    {
                      description: "Other Charges",
                      value: formatPrice(responseValues.charge),
                    },
                    {
                      description: "Cash Paid",
                      value: formatPrice(responseValues.cashpaid),
                    },
                    ...filteredBillValues.map((item) => ({
                      description: item.description,
                      value: item.value,
                    })),
                    {
                      description: "Total Paid",
                      value: formatPrice(responseValues.totPaid),
                    },
                  ]
                : []),
              ...(billExpanded
                ? [
                    {
                      description: "Net Amount",
                      value: formatPrice(responseValues.totNett),
                      highlight: true,
                    },
                    {
                      description:
                        responseValues.balance < 0 ? "Due Amount" : "Balance",
                      value: formatPrice(Math.abs(responseValues.balance)),
                    },
                  ]
                : [
                    {
                      description: "Net Amount",
                      value: formatPrice(responseValues.totNett),
                      highlight: true,
                    },
                  ]),
            ].map((item, index) => (
              <Grid container sx={styles.cs_summary_bill} key={index}>
                <Grid item xs={6} md={6} sx={styles.left_align}>
                  <Typography
                    sx={{
                      ...styles.cs_summary_description,
                      ...(item.highlight && styles.highlight), // Apply highlight if it's "Net Amount"
                    }}
                  >
                    {item.description}
                  </Typography>
                </Grid>

                <Grid item xs={6} md={6} sx={styles.right_align}>
                  {item.input ? (
                    <Grid container alignItems="center" sx={styles.right_align}>
                      <Grid item xs={8} md={8}>
                        {item.description === "Advance" ? (
                          // Check if orderBillDetails contains ADVANCEAMOUNT
                          orderBillDetails.items.length > 0 &&
                          orderBillDetails.items[0].ADVANCEAMOUNT > 0 ? (
                            // If ADVANCEAMOUNT exists, display it and disable the input
                            <TextField
                              size="small"
                              fullWidth
                              variant="outlined"
                              value={orderBillDetails.items[0].ADVANCEAMOUNT} // Bind the advanceAmount from the API
                              disabled // Disable the input
                              inputProps={{
                                inputMode: "decimal",
                                pattern: "^[0-9]*[.,]?[0-9]{0,2}$",
                              }}
                            />
                          ) : (
                            // If no ADVANCEAMOUNT (new order), allow the user to input the advance amount
                            <TextField
                              size="small"
                              fullWidth
                              variant="outlined"
                              value={advanceAmount} // Bind advance amount from state (for new orders)
                              onChange={handleAdvanceAmountChange} // Handler to update state
                              inputProps={{
                                inputMode: "decimal",
                                pattern: "^[0-9]*[.,]?[0-9]{0,2}$",
                              }}
                            />
                          )
                        ) : (
                          <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            value={cashTendered} // bind cash tendered state
                            onChange={handleCashTenderedChange}
                            inputProps={{
                              inputMode: "decimal",
                              pattern: "^[0-9]*[.,]?[0-9]{0,2}$",
                              // style: { textAlign: "right" },
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  ) : (
                    <Typography
                      sx={{
                        ...styles.cs_summary_price,
                        ...(item.highlight && styles.highlight_red), // Apply highlight if it's "Net Amount"
                      }}
                    >
                      {item.value}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            ))}

            <Grid gap={2} sx={styles.btn_group_bootom_align} mt={2}>
              <Button
                variant="outlined"
                onClick={handleClearCart}
                fullWidth
                size="medium"
                sx={styles.btn_secondary}
                startIcon={<AddCircleOutlineIcon />}
              >
                New
              </Button>
              <Button
                sx={styles.btn_secondary}
                onClick={onMoreClick}
                size="medium"
                variant="outlined"
              >
                More
              </Button>
            </Grid>
            <Grid gap={2} sx={styles.btn_group_bootom_align} mt={2}>
              <Button
                sx={styles.btn_primary}
                onClick={handlePlaceOrder}
                size="medium"
                variant="contained"
              >
                Place Order
              </Button>
              <Button
                sx={styles.btn_primary}
                onClick={handleConfirmOrder}
                size="medium"
                variant="contained"
              >
                Pay
              </Button>
            </Grid>
          </Box>
        </Box>

        {/* Bill Area end */}
        {/* Addon */}
        <Dialog
          open={isDialogOpen}
          onClose={() => setDialogOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Addons for : {currentItem?.MENUNAME}</DialogTitle>
          <DialogContent>
            <List>
              {addonsData.map((addon) => (
                <ListItem key={addon.ADDONCODE}>
                  <ListItemText
                    primary={addon.ADDONTYPE}
                    secondary={`LKR ${formatPrice(addon.RATE)}`}
                  />
                  <Checkbox
                    checked={selectedAddons.some(
                      (sel) => sel.ADDONCODE === addon.ADDONCODE
                    )}
                    onChange={(e) => handleAddonSelection(e, addon)}
                  />
                </ListItem>
              ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ ...styles.btn_secondary, width: "20%" }}
              onClick={() => setDialogOpen(false)}
              variant="outlined"
              color="error"
            >
              Cancel
            </Button>
            <Button
              sx={{ ...styles.btn_primary, width: "20%" }}
              onClick={handleSaveAddons}
              variant="contained"
              color="primary"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <SnackbarMessage
          open={snackbarOpen}
          handleClose={handleCloseSnackbar}
          message={snackbarMessage}
          severity={snackbarSeverity} // Dynamic severity (success or error)
        />
      </Grid>
    </>
  );
};

export default CashierSummaryMobile;
